import {Component, OnDestroy, OnInit} from '@angular/core';
import {SideNavService} from "../../services/side-nav.service";
import {Activity, Program, SchedulingParams, SiteTopology} from "../../domain/cloud-topology";
import {ActivatedRoute} from "@angular/router";
import {ReplaySubject, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {SiteService} from "../../services/site/site.service";
import moment from "moment-timezone";
import {ScheduleService} from "../../services/vpp/schedule.service";

@Component({
    selector: 'app-control',
    templateUrl: './control.component.html',
    styleUrls: ['./control.component.scss'],
    standalone: false
})
export class ControlComponent implements OnInit, OnDestroy {

  sites: SiteTopology[];
  programs: Program[];
  filter: SchedulingParams;
  activities: Activity[];
  holdUpdates: boolean = true;
  loading: boolean;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(private sideNavService: SideNavService,
              private siteService: SiteService,
              private scheduleService: ScheduleService,
              private route: ActivatedRoute) { }

  ngOnInit() {
    this.applyPresetToRoute();
    this.loading = true;
    this.sideNavService.getSiteCache().pipe(takeUntil(this.destroyed$)).subscribe(sites => {
      if (sites) {
        this.sites = sites;
        this.sideNavService.getProgramCache().pipe(takeUntil(this.destroyed$)).subscribe(programs => {
          if (programs) {
            this.programs = programs;
            this.getSchedules();
            this.holdUpdates = false;
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onParamChange($event) {
    this.filter = $event;
    this.getSchedules();
  }

  applyPresetToRoute(): void {
    const queryParamsCompleted$ = new Subject<void>();
    this.route.queryParams.pipe(takeUntil(queryParamsCompleted$)).subscribe(params => {
      if (params['filter']) {
        this.filter = JSON.parse(params['filter']);
      } else {
        this.filter = {
          sites: [],
          developers: [],
          accounts: [],
          programs: [],
          activityTypes: [],
          activityStatuses: [],
          systemTypes: [],
          startDate: moment().tz(moment.tz.guess()).format('YYYY-MM-DDT00:00:00Z'),
          stopDate: moment().add(1, 'days').tz(moment.tz.guess()).format('YYYY-MM-DDT00:00:00Z'),
          timezone: moment.tz.guess()
        }
      }
      queryParamsCompleted$.next();
      queryParamsCompleted$.complete();
    });
  }

  private getSchedules(): void {
    this.loading = true;
    const filter = Object.assign({}, this.filter);
    if (filter.startDate.indexOf('+') >= 0) {
      filter.startDate = filter.startDate.substring(0, filter.startDate.indexOf('+'));
    }
    if (filter.stopDate.indexOf('+') >= 0) {
      filter.stopDate = filter.stopDate.substring(0, filter.stopDate.indexOf('+'));
    }
    const correctedEndMillis = new Date(filter.stopDate).setMinutes(-(new Date(filter.stopDate).getTimezoneOffset())) - 1000 + 86400000;
    //const correctedStartMillis = new Date(filter.startDate).setMinutes(-(new Date(filter.startDate).getTimezoneOffset())) - 86400000;
    //filter.startDate = new Date(correctedStartMillis).toISOString().replace('.000Z', '');
    filter.stopDate = new Date(correctedEndMillis).toISOString().replace('.000Z', '');
    this.scheduleService.getSchedules(filter).pipe(takeUntil(this.destroyed$)).subscribe(data => {
      this.activities = data;
      this.loading = false;
    });
  }
}
